export const setAddressList = (list) => {
    let finalList = {};

    if (Array.isArray(list)) {
        list.forEach((item) => {
            finalList[item.ID] = {
                ...item,
            };
        });
    } else if (typeof list.ID != 'undefined') {
        finalList[list.ID] = list;
    } else {
        finalList = list;
    }

    return {
        type: 'UPDATE_ADDRESS_LIST',
        list: finalList,
    };
};
